
export const navigate2MyOffer = (id, selectedVersion) => {
  const params = new URLSearchParams();

  if (selectedVersion) {
    params.set("version", selectedVersion);
  }
  return `/view-offer/${id}/?${params.toString()}`;
};
